import { render, staticRenderFns } from "./numberformat.vue?vue&type=template&id=592c97fa&"
import script from "./numberformat.vue?vue&type=script&lang=js&"
export * from "./numberformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('592c97fa')) {
      api.createRecord('592c97fa', component.options)
    } else {
      api.reload('592c97fa', component.options)
    }
    module.hot.accept("./numberformat.vue?vue&type=template&id=592c97fa&", function () {
      api.rerender('592c97fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TN2Ec1A9uoO2/JS/comp/numberformat.vue"
export default component.exports